<script>
import Icon from "./Icon.vue";

export default {
  name: "ItemLink",
  components: {Icon},
  props: ['data'],
  methods: {
    getUrl(){
      return this.data.url || '#';
    }
  }
}
</script>

<template>
  <a :href="getUrl()" class="item-link" target="_blank">
    <div class="top">
      <div class="direction">{{data.code}}</div>
      <div class="image">
        <img v-if="data.src" :src="data.src">
        <Icon v-else name="empty-link" class="img-icon"/>
      </div>
      <div class="name">
        {{data.name}}
      </div>
    </div>
    <div class="bottom">
      <div class="arrow">
        <Icon name="arrow"/>
      </div>
    </div>
  </a>
</template>

<style scoped lang="scss">
  @import "/src/style/variable";

  .item-link {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: $color-white;
    padding: 30px 35px;
    border-radius: 20px;
    color: $color-orange;
    text-decoration: none;
    border: 2px solid $color-orange;
    .top {
      display: flex;
      flex-direction: column;
    }
    .bottom {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .arrow {
        svg {
          stroke: $color-blue;
        }
      }
    }
    &:hover {
      .name {
        text-decoration: underline;
      }
    }
    .direction {
      color: $color-blue;
      font-family: $font-family;
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 20px;
      span {
        opacity: 0.3;
      }
    }
    .image {
      margin-bottom: 20px;
      height: 150px;
      display: flex;
      justify-content: center;
      img {
        max-width: 100%;
        max-height: 100%;
      }
      .img-icon {
        width: 100%;
        height: auto;
      }
    }
    .name {
      color: $color-orange;
      font-family: $font-family;
      font-size: 20px;
      font-weight: 600;
    }
  }
</style>